// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { MatterDeadline } from "../../types";

const matterDeadlinesModule = {
  async findByMatterId(matterId: string, userId: string): Promise<MatterDeadline[]> {
    const result = await sql`
      SELECT * FROM matter_deadlines
      WHERE matter_id = ${matterId} AND user_id = ${userId}
      ORDER BY due_date ASC
    `;
    return (result || []) as MatterDeadline[];
  },

  async findUpcoming(userId: string, days: number = 30): Promise<MatterDeadline[]> {
    const result = await sql`
      SELECT md.*, m.title as matter_title
      FROM matter_deadlines md
      JOIN matters m ON m.id = md.matter_id
      WHERE md.user_id = ${userId} 
      AND md.is_completed = false
      AND md.due_date <= CURRENT_DATE + INTERVAL '${days} days'
      ORDER BY md.due_date ASC
    `;
    return (result || []) as MatterDeadline[];
  },

  async create(data: Omit<MatterDeadline, 'id' | 'created_at' | 'updated_at'>): Promise<MatterDeadline> {
    const result = await sql`
      INSERT INTO matter_deadlines (
        matter_id, user_id, title, description, due_date, reminder_date, is_completed
      )
      VALUES (
        ${data.matter_id}, ${data.user_id}, ${data.title}, ${data.description}, 
        ${data.due_date}, ${data.reminder_date}, ${data.is_completed || false}
      )
      RETURNING *
    `;
    return result[0] as MatterDeadline;
  },

  async update(id: string, userId: string, data: Partial<MatterDeadline>): Promise<MatterDeadline> {
    const result = await sql`
      UPDATE matter_deadlines
      SET 
        title = CASE WHEN ${data.title === undefined} THEN title ELSE ${data.title} END,
        description = CASE WHEN ${data.description === undefined} THEN description ELSE ${data.description} END,
        due_date = CASE WHEN ${data.due_date === undefined} THEN due_date ELSE ${data.due_date} END,
        reminder_date = CASE WHEN ${data.reminder_date === undefined} THEN reminder_date ELSE ${data.reminder_date} END,
        is_completed = CASE WHEN ${data.is_completed === undefined} THEN is_completed ELSE ${data.is_completed} END,
        completed_at = CASE 
          WHEN ${data.is_completed === undefined} THEN completed_at 
          WHEN ${data.is_completed} = true THEN NOW()
          ELSE NULL
        END
      WHERE id = ${id} AND user_id = ${userId}
      RETURNING *
    `;
    return result[0] as MatterDeadline;
  },

  async delete(id: string, userId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM matter_deadlines
      WHERE id = ${id} AND user_id = ${userId}
    `;
    return result.count === 1;
  }
};

export type MatterDeadlinesModule = typeof matterDeadlinesModule;

export function registerMatterDeadlines(db: { matterDeadlines?: MatterDeadlinesModule }) {
  db.matterDeadlines = matterDeadlinesModule;
}

export { matterDeadlinesModule as matterDeadlines };
